import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=5716ed3f&scoped=true"
import script from "./apps.vue?vue&type=script&lang=ts"
export * from "./apps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5716ed3f",
  null
  
)

export default component.exports